module.exports = __webpack_public_path__ + "img/Adiamante.f37d608f.png";